/* eslint-disable @typescript-eslint/camelcase */
import MESSAGES from 'constants/messages';
import { stringMaxLengthIsInvalid } from 'store/utils/validators';

import { setWith, isEmpty } from 'lodash';

const NAME_REGEXP = /^[a-zA-Z]+[a-zA-Z0-9_.-]*$/;
const CONDITION_OPERATOR_REGEXP = /^exists|not_exists|exists_optionally$/;

export const validate = values => {
  const constraintSets = values.constraint_sets;
  const errors = {};

  if (!values.name || !values.name.match(NAME_REGEXP)) {
    errors.name = MESSAGES.INTENTS.NAME.REGEX.UPDATE;
  }

  if (stringMaxLengthIsInvalid(values.name)) {
    errors.name = MESSAGES.INTENTS.NAME.MAX_LENGTH;
  }

  if (!isEmpty(constraintSets)) {
    constraintSets.forEach(({ conditions, intent_reference }, i) => {
      if (!intent_reference || intent_reference === '') {
        setWith(
          errors,
          ['constraint_sets', i, 'all_references'],
          MESSAGES.INTENTS.REFERENCE.REQUIRED,
        );
      }

      conditions.forEach(({ operator, entity_reference_obj }, j) => {
        const path = ['constraint_sets', i, 'conditions', j];

        if (!entity_reference_obj.name) {
          setWith(errors, [...path, 'name'], MESSAGES.INTENTS.ENTITY.REQUIRED);
        }

        if (!operator || !operator.match(CONDITION_OPERATOR_REGEXP)) {
          setWith(
            errors,
            [...path, 'operator'],
            MESSAGES.INTENTS.OPERATOR.REQUIRED,
          );
        }
      });
    });
  }

  return errors;
};

export default validate;
